export default function NewsListPage() {
    return (
        <div className="py-10">
            <h1 className="text-4xl font-black uppercase text-white">Actualités</h1>
        </div>
    );
}